import './card-people.scss';

export default () => {
};
